import { createContext, useContext } from 'react'
import { type TagsDropdownStore } from '../store/tagsDropdownStore'

export const TagsDropdownContext = createContext<TagsDropdownStore | null>(null)

export function useTagsDropdownContext() {
  const context = useContext(TagsDropdownContext)
  if (context === null) {
    throw new Error('You have forgotten to wrap your root component with TagsDropdownStoreProvider')
  }
  return context
}
